import * as THREE from 'three';
import {
  CARD1Web, MouseAction
} from './CoordUtils.js'
import './camera.js'
import {
  RoadManager
} from './RoadManager.js'

import {
  AsyncTask
} from '@/js/task.js'
import ViewBasicControl from '@/components/Web3dModels/ViewBasicControls'
import RoadUnitData from '@/components/Web3dModels/RoadUnitData'

import { Navigator } from './navigation'
import {ModelLoader} from '@/drawings3D/ModelLoader'
import  {GeometryManager} from './GeometryManager'
import  {AnimationManager} from './AnimationManager'

import {WorkerLoader} from '@/drawings3D/modelDrawing/DirectModel/WorkerLoader'
import {MonitorLoader} from '@/drawings3D/modelDrawing/DirectModel/MonitorLoader'
import {Car1Loader} from '@/drawings3D/modelDrawing/DirectModel/Car1Loader'
import {CommonLoader} from '@/drawings3D/modelDrawing/DirectModel/CommonLoader'

import {FenceDrawer} from '@/drawings3D/modelDrawing/FenceDrawer'

import { RenderPass, EffectComposer, OutlinePass } from "three-outlinepass"

// import Viewer from "cesium/Source/Widgets/Viewer/Viewer";

export class SceneManager {
  constructor(domElementId, webView) {
    this.webView = webView;
    this.scene = new THREE.Scene();
    this.renderer = new THREE.WebGLRenderer({alpha: true});
    this.renderer.setClearColor(0xffffff, 0.0);
    this.renderer.setSize($(window).width(), $(window).height());
    $("#WebGL-output").height($(window).height());
    this.renderer.shadowMap.Enabled = true;
    this.activeCamera = this.camera = new CARD1Web.Camera(new THREE.Vector3(80, 80, 80), new THREE.Vector3(0, 0, 0), this);
    this.assistCameraInCar = new CARD1Web.Camera(new THREE.Vector3(80, 80, 80), new THREE.Vector3(0, 0, 0), this);
    this.clock = new THREE.Clock();
    document.getElementById(domElementId).append(this.renderer.domElement);

    //object management
    this.model = new Object();

    //道路管理
    this.model.roadManager = new RoadManager( this, this.webView.axios, this.webView);


    //light management
    // add subtle ambient lighting
    var ambientLight = new THREE.AmbientLight(0x0c0c0c);
    this.scene.add(ambientLight);

    //渲染天空
    this.scene.background = new THREE.CubeTextureLoader()
      .setPath( '/static/bimroad/textures/sky/' )
      .load( [
        'px.jpg',
        'nx.jpg',
        'py.jpg',
        'ny.jpg',
        'pz.jpg',
        'nz.jpg'
      ] );
    this.createDirectLight(new THREE.Vector3(-5000, -5000, 0), new THREE.Vector3(5000, 5000, 0));
    this.createDirectLight(new THREE.Vector3(5000, 5000, 0), new THREE.Vector3(-5000, -5000, 0));

    this.createDirectLight(new THREE.Vector3(0, -5000, -5000), new THREE.Vector3(0, 5000, 5000));
    this.createDirectLight(new THREE.Vector3(0, 5000, 5000), new THREE.Vector3(0, -5000, -5000));

    this.createDirectLight(new THREE.Vector3(0, 5000, 0), new THREE.Vector3(0, -5000, 0));
    this.createDirectLight(new THREE.Vector3(0, -5000, 0), new THREE.Vector3(0, 5000, 0));

    //坐标轴
    // this.coord = new CARD1Web.CoordUtils.Coord(this.scene, {
    //   x: 0,
    //   y: 0,
    //   z: 0
    // });
    // this.coord.hide();
    this.lastMaterail = null;

    this.geometryManager = new GeometryManager(this);

    this.animationManager = new AnimationManager(this);

    this.currentMouseMovementAction = {mouse: MouseAction.NONE};
    
    //sos模型框线和搜索模型框线
    this.compose = new EffectComposer(this.renderer);
    var selectedObjects = []
    this.renderPass = new RenderPass(this.scene,this.activeCamera.get());
    this.outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), this.scene, this.activeCamera.get(), selectedObjects);
    this.outlinePass.renderToScreen = true;
    this.outlinePass.selectedObjects = selectedObjects;
    
    var selectedObjects1=[];
    this.outlinePassSearch = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), this.scene, this.activeCamera.get(), selectedObjects1);
    this.outlinePassSearch.renderToScreen = true;
    this.outlinePassSearch.selectedObjects = selectedObjects1;
    
    //目前用于病害选中状态
    var selectedObjects2=[];
    this.outlinePassGreen = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), this.scene, this.activeCamera.get(), selectedObjects2);
    this.outlinePassGreen.renderToScreen = true;
    this.outlinePassGreen.selectedObjects = selectedObjects2;

    this.compose.addPass(this.renderPass);
    this.compose.addPass(this.outlinePass);
    this.compose.addPass(this.outlinePassSearch);
    this.compose.addPass(this.outlinePassGreen);
    var params = {
        edgeStrength: 4.7,
        edgeGlow: 0,
        edgeThickness: 1.8,
        pulsePeriod: 2,//闪动效果，值越大闪动越慢
        usePatternTexture: false
    };
     
    var sosParams = {
        edgeStrength: 4.7,
        edgeGlow: 1,
        edgeThickness: 2.8,
        pulsePeriod: 1,//闪动效果，值越大闪动越慢
        usePatternTexture: false
    };
    this.outlinePass.edgeStrength = sosParams.edgeStrength;
    this.outlinePass.edgeGlow = sosParams.edgeGlow;
    this.outlinePass.pulsePeriod = sosParams.pulsePeriod;
    this.outlinePass.edgeThickness = sosParams.edgeThickness;
    this.outlinePass.visibleEdgeColor.set('#e3cb1b');
    this.outlinePass.hiddenEdgeColor.set('#e3cb1b');
    
    this.outlinePassSearch.edgeStrength = params.edgeStrength;
    this.outlinePassSearch.edgeGlow = params.edgeGlow;
    this.outlinePassSearch.pulsePeriod = params.pulsePeriod;
    this.outlinePassSearch.edgeThickness = params.edgeThickness;
    this.outlinePassSearch.visibleEdgeColor.set('#2c9ba2');//模型可见部分框线颜色
    this.outlinePassSearch.hiddenEdgeColor.set('#bf24e1');//模型不可见框线颜色

    this.outlinePassGreen.edgeStrength = params.edgeStrength;
    this.outlinePassGreen.edgeGlow = params.edgeGlow;
    this.outlinePassGreen.pulsePeriod = params.pulsePeriod;
    this.outlinePassGreen.edgeThickness = params.edgeThickness;
    this.outlinePassGreen.visibleEdgeColor.set('#1fe62b');//模型可见部分框线颜色
    this.outlinePassGreen.hiddenEdgeColor.set('#1fe62b');//模型不可见框线颜色


    // this.compose.render(this.scene, this.activeCamera.get()) 
  }
  checkClickObj(action, web3DVue) {
    this.currentMouseMovementAction.mouse = action;
    this.geometryManager.getSelectMesh(event.clientX, event.clientY, this.currentMouseMovementAction, web3DVue);
    
  }
  moveCamera(point) {

  }

  createDirectLight(pos, targetPos){
        var pointColor = "#ffffff";
        var directionalLight = new THREE.DirectionalLight(pointColor);
        directionalLight.position.copy(pos);
        directionalLight.castShadow = false;
        directionalLight.shadowCameraNear = 2;
        directionalLight.shadowCameraFar = 8000;
        directionalLight.shadowCameraLeft = -50;
        directionalLight.shadowCameraRight = 50;
        directionalLight.shadowCameraTop = 50;
        directionalLight.shadowCameraBottom = -50;

        directionalLight.distance = 0;
        directionalLight.intensity = 0.5;
        directionalLight.shadowMapHeight = 1024;
        directionalLight.shadowMapWidth = 1024;
        directionalLight.shadowCameraVisible = true

        var target = new THREE.Object3D();
        target.position.copy(targetPos);
        this.scene.add(target);
        directionalLight.target = target;
        this.scene.add(directionalLight);
  }

  switchCamera(camera){
    if (camera != undefined) {
      this.activeCamera = camera;
      return;
    }
    if (this.activeCamera === this.camera){
      this.activeCamera = this.assistCameraInCar;
    }
    else{
      this.activeCamera = this.camera;
    }
  }

   renderSky() {
    if (this.sky == undefined) {
      // LIGHTS
      var hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
      hemiLight.color.setHSL(0.6, 1, 0.6);
      hemiLight.groundColor.setHSL(0.095, 1, 0.75);
      //添加天空
      var vertexShader = document.getElementById('vertexShader').textContent;
      var fragmentShader = document.getElementById('fragmentShader').textContent;
      var uniforms = {
        topColor: { value: new THREE.Color(0x0077ff) },
        bottomColor: { value: new THREE.Color(0xffffff) },
        offset: { value: 3 },
        exponent: { value: 3 }
      };
      uniforms.topColor.value.copy(hemiLight.color);
      var skyGeo = new THREE.SphereBufferGeometry(this.camera.get().far, 32, 15);
      var skyMat = new THREE.ShaderMaterial({ vertexShader: vertexShader, fragmentShader: fragmentShader, uniforms: uniforms, side: THREE.BackSide });
      var sky = new THREE.Mesh(skyGeo, skyMat);
      this.sky = sky;
      this.scene.add(sky);
    }
    this.sky.position.copy(this.camera.get().position);

  }
  calcNormal(vertices){
      var length = vertices.length;
      var a1 = new THREE.Vector3(vertices[length - 9], vertices[length - 8], vertices[length - 7]);
      var a2 = new THREE.Vector3(vertices[length - 6], vertices[length - 5], vertices[length - 4]);
      var a3 = new THREE.Vector3(vertices[length - 3], vertices[length - 2], vertices[length - 1]);
      a2.sub(a1).cross(a3.sub(a1));
      return a2.normalize();
  }

  swithEarthPlane(wireframe){
    if (wireframe){
      this.scene.remove(this.imagenaryEarthPlane);
      this.scene.add(this.wirefrmaeEarthPlane);
    }
    else{
      this.scene.remove(this.wirefrmaeEarthPlane);
      this.scene.add(this.imagenaryEarthPlane);
    }
  }

  getRoadManager() {
    return this.model.roadManager;
  }

  render(scope) {
    var delta = this.clock.getDelta();

    this.animationManager.moveAFrame(delta);
    // if (this.roadNav && this.roadNav.state == 1) {
    //   this.roadNav.moveAFrame(delta);
    // }

    //this.camera.updateTrackballController(delta);

    this.camera.checkPos(delta);
    if(this.labelRenderer){
       this.labelRenderer.render( this.scene,this.activeCamera.get(delta));
    }
    if(this.panelRenderer){
       this.panelRenderer.render( this.scene,this.activeCamera.get(delta)); 
    }
    this.renderer.render(this.scene, this.activeCamera.get());
    //模拟驾驶inCar和compose有冲突，且compose必须在this.renderer之后才有outline效果
    //用于处理模拟驾驶inCar和后期处理通道的冲突
    this.renderPass.camera=this.activeCamera.get();
    this.outlinePass.renderCamera=this.activeCamera.get();
    this.outlinePassSearch.renderCamera=this.activeCamera.get();
    this.compose.render();
    requestAnimationFrame(scope.render);    
  }

  loadModel(modelInfo, modelLoader){
      var loadedModel = modelLoader.loadModel(new THREE.Vector3(0, 0, 0));
     
  }

  loadDirectModelFromLoader(loaderOption, loader){

      var loadedModel = this.geometryManager.addModel(loaderOption, loader.loadModel());
      this.currentMouseMovementAction.model = loadedModel;
      loadedModel.loader = loader;
  }
  fixModelAtPos(pos){
      var loadedMesh = this.currentMouseMovementAction.model;
      loadedMesh.traverse(function(child) {
              if(child instanceof THREE.Mesh) {
                if (child.material.length){
                  child.material.map(item=>{
                      item.transparent=false;
                      item.opacity = 1;
                  })
                }
                else{
                  child.material.transparent = false;
                  child.material.opacity = 1;
                }
                
              }
            });
      this.currentMouseMovementAction.model = undefined; 
  }

  toMoveModel(model){

    this.currentMouseMovementAction.model = model;
        model.traverse(function(child) {
          if (child instanceof THREE.Mesh) {
            if (child.material.length){
              child.material.map(item => {
              item.transparent = true;
              item.color = new THREE.Color( 0xff0000 );
              item.opacity = 0.3;
            })  
            }
            else{
               child.material.transparent = true;
                child.material.opacity = 0.3;
            }
            
          }
        });
  }


  unloadModel(){
      this.currentMouseMovementAction.model = undefined;
  }

  getWorkerLoader(workerOption){
    
    var modelLoader = new WorkerLoader(workerOption, this);
     return modelLoader;
  }
  
  getCar1Loader(car1Option){
    
    var modelLoader = new Car1Loader(car1Option, this);
     return modelLoader;
  }

  getMonitorLoader(monitorOption){
    
    var modelLoader = new MonitorLoader(monitorOption, this);
     return modelLoader;
  }
  getCommonLoader(commonOption){
    var commonLoader=new CommonLoader(commonOption,this);
    return commonLoader;
  }

  drawFence(fenceData){
    var fenceDrawer = new FenceDrawer(fenceData, this);
    fenceDrawer.draw();
  }

  //根据传入的三维坐标系中的点得到其对应的平面坐标系坐标
  getScreenPos(vector){
      let size = new THREE.Vector2();
      this.renderer.getSize(size);
      let halfWidth =  size.width/ 2;
      let halfHeight = size.height / 2;

       var pos = vector.clone().project(this.camera.get());
      var left = pos.x * halfWidth + halfWidth;
      var top = -pos.y * halfHeight + halfHeight;
      return new THREE.Vector2(left, top);
  }

  resetCameraPosStatus(setPos){
    this.camera.uploadInProgress = false;
    if (setPos){
      this.camera.setLastUpdateRoadPos();  
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/plugins/drawings3D/sceneManager.js